import React from 'react';
import {SubtractionType} from "../../../../../../../../api/generated";
import {CustomSmallInputField} from "../../../../../../../elements/customSmallInputField/CustomSmallInputField";
import {SubtractInputField} from "../../../../../../../elements/subtractInputField/SubtractInputField";
import {DeleteButton} from "../../../../../../../elements/deleteButton/DeleteButton";
import {UpdateRetailPriceRuleRequest} from "../../../../../../../../api/generated";
import styles from "./SubtractionRule.module.css";

export interface ErrorState {
    maxValueErrorMessage?: string;
    subtractionErrorMessage?: string;
}

interface Props {
    rule: UpdateRetailPriceRuleRequest;
    index: number;
    isLastItem: boolean;
    canBeDeleted: boolean;
    errorState?: ErrorState;
    addNewRetailPriceRule: (previousRuleIndex: number) => void;
    updateRetailPriceRule: (index: number, rule: UpdateRetailPriceRuleRequest) => void;
    deleteRetailPriceRule: (ruleIndex: number) => void;
    disabled?: boolean;
}

export const SubtractionRule: React.FC<Props> = ({
    rule,
    index,
    isLastItem,
    canBeDeleted,
    errorState,
    addNewRetailPriceRule,
    updateRetailPriceRule,
    deleteRetailPriceRule,
    disabled
}) => {
    const subtraction = rule.subtraction;

    const handleUpdateSubtractionValue = (value: string) => {
        const numValue = Number(value) || 0;
        updateRetailPriceRule(index, {
            ...rule,
            subtraction: {
                ...subtraction,
                subtractionValue: numValue
            }
        });
    };

    const handleUpdateSubtractionType = (type: SubtractionType) => {
        updateRetailPriceRule(index, {
            ...rule,
            subtraction: {
                ...subtraction,
                subtractionType: type
            }
        });
    };

    const handleUpdateMax = (value: string) => {
        const numValue = Number(value);
        updateRetailPriceRule(index, {...rule, max: numValue});
    };

    return (
        <div className={styles.wrapper} key={index}>
            <div className={styles.upperLineWrapper}>
                <div
                    className={styles.verticalLineWrapper}
                    onClick={() => !disabled && addNewRetailPriceRule(index)}
                >
                    <div className={styles.verticalLine}>
                        <span className={styles.plus}>+</span>
                    </div>
                </div>
                <SubtractInputField
                    type="number"
                    value={subtraction.subtractionValue === -1 ? undefined : subtraction.subtractionValue}
                    setValue={handleUpdateSubtractionValue}
                    subtractionType={subtraction.subtractionType as SubtractionType}
                    onSubtractionChange={handleUpdateSubtractionType}
                    disabled={disabled}
                    placeholder="value"
                    errorMessage={errorState?.subtractionErrorMessage}
                />
                <div className={styles.deleteWrapper}>
                    <DeleteButton
                        disabled={!canBeDeleted || disabled}
                        handleClick={() => deleteRetailPriceRule(index)}
                    />
                </div>
            </div>
            <div className={styles.bottomLineWrapper}>
                <CustomSmallInputField
                    type="number"
                    readOnly={isLastItem}
                    placeholder={isLastItem ? "max value" : "value"}
                    value={isLastItem ? "" : rule.max}
                    errorMessage={errorState?.maxValueErrorMessage}
                    setValue={handleUpdateMax}
                    disabled={disabled}
                />
            </div>
        </div>
    );
};
